<template>
 <div style="flex:1 0 auto;position:relative;" v-if="canRender">
    <v-card class="ma-2 maincontent" >      
      <v-card-title style="flex-direction:column;align-items:stretch;height:100%;">
        <h2 style="flex:0 0 auto;">{{$t('Admin.CmdCompletion.FullTitle')}}  <label class="text-reader v-btn theme--light ml-0">
                <div class="v-btn__content">        
                  {{$t("Admin.CmdCompletion.ReadCmdFile")}}
                  <v-icon right>mdi-file-download-outline</v-icon>                          
                  <input type="file" ref="cmdFileInput" @change="readCmdFromFile">
                </div>
              </label>  </h2>                       
         <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
          <v-flex class="px-4">
             
              <v-textarea                   
                :label="$t('Admin.CmdCompletion.List')"
                v-model="cmdListStr"                    
                rows="10"
                auto-grow
            ></v-textarea>
          </v-flex>                         
        </v-layout>  
        <v-layout class="pt-2 adm-button" row wrap >          
          <v-btn :disabled="loading || !modified" @click.prevent="annuler">{{$t('Admin.Cancel')}}<v-icon right>mdi-restore</v-icon></v-btn>
          <v-btn :disabled="loading || !modified" @click.prevent="sauvegarde">{{$t('Admin.Save')}}<v-icon right>mdi-content-save</v-icon></v-btn>
        </v-layout>          
      </v-card-title>          
    </v-card> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import camelCase from 'lodash.camelcase'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { DataPoolGlobalKeys } from '@/enum/DataPool'
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'
import {GliderCmd} from '@/models/datapool/GliderCmd'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


@Component({
  name: 'AdminCmdCompletion'  
})
export default class AdminCmdCompletion extends Vue {      
    
  loading = false
  status = ""
  cmdListStr = ""
  canRender = true 

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_COMMAND_COMPLETION].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }

  get originalCmdListStr() {
    const list = (this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.cmdCompletion']) as string | null || "").split('\n').filter(t => t && t.length > 0).sort()    
    return  list.join('\n')
  }

  get modified() {
    return this.originalCmdListStr != this.cmdListStr
  }

  mounted(){
    this.loading = true
    this.status = this.$t('Admin.CmdCompletion.Loading').toString()
    this.$store.myActions.DATAPOOL_ENSURE({fullKey:DataPoolGlobalKeys['global.config.cmdCompletion']}).then(()=>{
      this.annuler()
      this.status = this.$t('Admin.CmdCompletion.Loaded').toString()
    }).finally(()=>{
      this.loading = false;
    });    
  }
  

  /*Fonctions*/  
  sauvegarde() {
    //@ts-ignore
    this.status = this.$t('Admin.CmdCompletion.Loading').toString()
    this.loading = true
    this.$store.myActions.DATAPOOL_UPDATE_REQUEST(
        new AloDataPoolItem({
        dtaValue:this.cmdListStr,
        dtaKey:DataPoolGlobalKeys['global.config.cmdCompletion']
      })).then((data)=>{
        this.status = this.$t('Admin.CmdCompletion.Loaded').toString()
        this.annuler()
      }).finally(()=>{
        this.loading = false
      })      
  }
  
  annuler() {
    //@ts-ignore
    this.cmdListStr = this.originalCmdListStr
  }

  readCmdFromFile(ev:any) {
    const file = ev.target.files[0];
    const reader = new FileReader();
    //@ts-ignore
    reader.onload = e => this.cmdListStr = e.target.result
    reader.readAsText(file)
  }
}
</script>